import React, { SVGProps } from "react";

export default function SupOpenModal(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.34324 15.6568L5.05035 10.7071L6.81812 12.4749L11.0608 8.23222L11.7679 8.93933L7.52522 13.182L9.29299 14.9497L4.34324 15.6568ZM5.75746 12.8284L5.52176 14.4783L7.17167 14.2426L5.75746 12.8284Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.657 4.34313L10.7072 5.05024L12.475 6.81801L8.23233 11.0606L8.93944 11.7678L13.1821 7.52511L14.9498 9.29288L15.657 4.34313ZM12.8285 5.75735L14.4784 5.52165L14.2427 7.17156L12.8285 5.75735Z"
        fill="currentColor"
      />
    </svg>
  );
}
